<script module lang="ts">
  import type { SystemStyleObject } from '@agapi/ui/panda/types';

  export interface ComboboxItemProps {
    label: string;
    value: string;
  }

  export interface ComboboxItemComponentProps {
    item: ComboboxItemProps;
    css?: SystemStyleObject;
  }
</script>

<script lang="ts">
  import { useComboboxContext } from '../use-combobox-context';
  import { comboboxStyles } from '../combobox.styles';
  import { css } from '@agapi/ui/panda/css';

  const { item, css: cssProp }: ComboboxItemComponentProps = $props();
  const combobox = useComboboxContext();
  const classes = comboboxStyles.raw();

  // console.log(combobox)

  // console.log(item)

</script>

<li {...combobox.api.getItemProps({ item })} class={css(classes.item, cssProp)}>
  <span>{item.label}</span>
</li>